// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gEN2","right":"styles_right__Xro_n"};